import React from "react";
import styled from "styled-components";
import { Section, Box, Heading, Text, SocialIcons } from "../../theme";
import { Link } from "react-router-dom";
import Truncate from "react-truncate";
const SideBarLink = styled(Link)`
  font-size: 13px;
  width: 100%;
  display: block;
  text-align: center;
  color: #344556;
  text-decoration: none;
  font-family: sans-serif;
  margin-bottom: 8px;
  line-height: 1.6;
`;
SideBarLink.defaultProps = {
  to: "/"
};
export const SideBar = ({ display, aboutTitle, aboutText, ...rest }) => {
  return (
    <Section
      borderLeft="1px solid lightgray"
      bg="secondaryLight"
      display={display}
      {...rest}
    >
      {display !== "none" && (
        <Box pt={5} px={4}>
          <Heading fontSize={3} textAlign="center">
            {aboutTitle}
          </Heading>
          {aboutText && (
            <Box>
              <Text textAlign="center" fontSize={0}>
                {aboutText}
              </Text>
            </Box>
          )}
          <Heading fontSize={3} textAlign="center">
            Media Inquiries
          </Heading>
          <SideBarLink>Email: Media@emlaw.com</SideBarLink>
          <SideBarLink>Tel: (865) 525-5293</SideBarLink>
          <SocialIcons />
          <Box>
            <Heading mt={3} fontSize={3} textAlign="center">
              Latest News
            </Heading>
            <SideBarLink>
              Rocky King Co-chair of Tennessee Defensive Lawyers Association
              Annual Meeting
            </SideBarLink>
            <SideBarLink>
              Creative Caffeine Event July 24th, 2018 at 7:30-9:30 am How
              advertising claims affect your business
            </SideBarLink>
            <SideBarLink>
              Privacy Lunch and Learn Wednesday, July 18, 2018 at 11:30am Learn
              what it takes to comply with the latest privacy laws
            </SideBarLink>
            <SideBarLink>
              Susanne Kozma and Andrew Tucker join Egerton McAfee as our newest
              Associates{" "}
            </SideBarLink>
          </Box>
        </Box>
      )}
    </Section>
  );
};
